import api from '../api';

export const linkPasswordsService = async (email: string): Promise<string> => {
  const { data } = await api.post<{ link: string }>('/passwords/link', {
    email,
  });

  return data.link;
};
